import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'require_payment',
    props: {
        common: {}
    },
    setup(__props) {
        const props = __props;
        const onClickPaymentCard = () => {
            Inertia.get(route('payment.show'));
        };
        const onClickPlan = () => {
            Inertia.get(route('plan.show'));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        id: "all_wrapper",
                        class: "payment_entry"
                    }, [
                        _createElementVNode("div", { class: "wrapper_1" }, [
                            _cache[2] || (_cache[2] = _createElementVNode("h2", null, "基本料金のお支払い", -1)),
                            _createElementVNode("div", { class: "inner" }, [
                                _createElementVNode("form", null, [
                                    _cache[0] || (_cache[0] = _createElementVNode("dl", { style: { "text-align": "center" } }, [
                                        _createTextVNode(" ①"),
                                        _createElementVNode("b", null, "クレジットカード登録"),
                                        _createTextVNode("をしてから"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" ②"),
                                        _createElementVNode("b", null, "基本料金決済"),
                                        _createTextVNode("を行ってください。 ")
                                    ], -1)),
                                    _createElementVNode("div", { style: { "text-align": "center" } }, [
                                        _createElementVNode("a", {
                                            onClick: onClickPaymentCard,
                                            style: { "cursor": "pointer" }
                                        }, "①クレジットカード登録")
                                    ]),
                                    _cache[1] || (_cache[1] = _createElementVNode("div", { style: { "text-align": "center" } }, " ↓ ", -1)),
                                    _createElementVNode("div", { style: { "text-align": "center" } }, [
                                        _createElementVNode("a", {
                                            onClick: onClickPlan,
                                            style: { "cursor": "pointer" }
                                        }, "②基本料金決済")
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
